/** Shared primary action styling (green pill) for route-level CTAs */
export const PRIMARY_CTA_CLASS =
  'py-3 px-8 rounded-xl bg-[#13ec5b] text-base font-bold text-slate-900 cursor-pointer shadow-[0px_10px_15px_-3px_rgba(19,236,91,0.2),0px_4px_6px_-4px_rgba(19,236,91,0.2)] hover:brightness-95 transition-all';
